<template>
  <div class="contact">
    <div class="contact-left" v-if="false">
      <div class="contact-list-title">群组</div>
      <div class="group-list">
        <div v-for="(group, key) in groups || []" :key="key" class="group-item"
          :class="{ actived: profile.group && profile.group.id === group.id }" @click="groupChat(group)">
          <div class="group-avatar">
            <img :src="group.url" />
          </div>
          <div class="group-name">{{ group.name.length > 6 ? group.name.substr(0, 6) + "..." : group.name }}({{
            group.userIds.length }})</div>
        </div>
      </div>
    </div>
    <div class="conversation-list-content">
          <div v-if="conversations.length">
            <router-link
              tag="div" replace
              v-for="(conversation, key) in conversations" :key="key"
              :to="chatLocation(conversation)"
            >
              <div class="conversation" @contextmenu.prevent.stop="e => showRightClickMenu(e,conversation)">
                <div class="avatar">
                  <img :src="conversation.data.avatar"/>
                  <div v-if="conversation.unread>0"
                       class="unread-count">
                    <span class="unread">{{ conversation.unread }}</span>
                  </div>
                </div>
                <div class="conversation-message">
                  <div class="conversation-top">
                    <span class="conversation-name">{{ conversation.data.name }}</span>
                    <div class="conversation-time">
                      <div>{{ formatDate(conversation.lastMessage.timestamp) }}</div>
                    </div>
                  </div>
                  <div class="conversation-bottom">
                    <div class="conversation-content" v-if="conversation.lastMessage.recalled">
                      <div>{{conversation.lastMessage.recaller.id === currentUser.id ? '你' : `${conversation.lastMessage.recaller.data.name}`}}撤回了一条消息</div>
                    </div>
                    <div class="conversation-content" v-else>
                      <div class="unread-text"
                           v-if="conversation.lastMessage.read === false && conversation.lastMessage.senderId === currentUser.id">
                        [未读]
                      </div>
                      <div v-if="conversation.type === 'private'">
                        {{ conversation.lastMessage.senderId === currentUser.id ? '我' : conversation.data.name }}:
                      </div>
                      <div v-else>
                        {{ conversation.lastMessage.senderId === currentUser.id ? '我' : conversation.lastMessage.senderData.name }}:
                      </div>
                      <span class="text" v-if="conversation.lastMessage.type === 'text'">{{conversation.lastMessage.payload.text}}</span>
                      <span v-else-if="conversation.lastMessage.type === 'video'">[视频消息]</span>
                      <span v-else-if="conversation.lastMessage.type === 'audio'">[语音消息]</span>
                      <span v-else-if="conversation.lastMessage.type === 'image'">[图片消息]</span>
                      <span v-else-if="conversation.lastMessage.type === 'file'">[文件消息]</span>
                      <span v-else-if="conversation.lastMessage.type === 'order'">[订单消息]</span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div v-else class="no-conversation">- 当前没有会话 -</div>
        </div>
  </div>
</template>

<script>
// import restApi from "../api/restapi";

export default {
  data() {
    return {
      friends: [],
      groups: [],
      profile: {
        friend: null,
        group: null
      },
      showEmpty:false
    };
  },
  created() {
    // restApi.getGroups().then(({ data: { message, data } }) => {
    //   if (message) {
    //     // console.log("data",data)
    //     this.groups = data;
    //   }else{
    //     this.showEmpty=true;
    //   }
    // });
  },
  mounted() {

  },
  methods: {
    groupChat(group) {
      this.profile.friend = null;
      this.profile.group = group;
      this.profile.group.members = [];
    }
  },
};
</script>

<style scoped>

.contact {
  width: 100%;
  height: 100%;
  display: flex;
  background: #F7F7F7;
  color: #333333;
}

.contact-left {
  width: 220px;
  height: 100%;
  overflow: auto;
  border-right: #dbd6d6 1px solid;
}

.contact-list-title {
  margin: 10px 20px;
  font-size: 14px;
}

.friend-list {
  display: flex;
  flex-direction: column;
}

.group-list {
  display: flex;
  flex-direction: column;
}

.actived {
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
}

.friend-item {
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
}

.friend-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 10%;
  margin-left: 10px;
}

.friend {
  width: 65%;
  margin: 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-left: 10px;
}

.friend-name {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
}

.friend-mail {
  line-height: 21px;
  color: #888888;
}

.group-item {
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
  align-items: center;
}

.group-avatar {
  width: 40px;
  height: 40px;
  margin-left: 10px;
}

.group-avatar img {
  width: 40px;
  height: 40px;
}

.group-name {
  margin-left: 10px;
  width: 160px;
  text-align: left;
  font-size: 14px;
  line-height: 40px;
}

.contact-main {
  flex: 1;
  background: #FFFFFF;
}

.profile-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.profile-card-title {
  flex: 1;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.profile-name {
  width: 300px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.icon-zhanghu {
  font-size: 26px;
  color: #eeeeee;
  margin-right: 10px;
}

.profile-avatar {
  width: 80px;
}

.profile-avatar img {
  width: 80px;
  height: 80px;
  border-radius: 10%;
}

.friend-info {
  padding: 10px 30px;
  display: flex;
  justify-content: space-around;
  text-align: left;
  font-size: 14px;
  line-height: 45px;
}

.info-name {
  width: 100px;
}

.info-text {
  width: 200px;
}

.group-profile-name {
  font-size: 18px;
  padding: 20px 70px;
  border-bottom: 1px solid #eeeeee;
}

.group-members {
  width: 400px;
  min-height: 200px;
  margin: 20px auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.group-members .member {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;

}

.group-members .member-avatar {
  width: 58px;
  margin-top: 20px;
  border-radius: 5%;
}

.group-members .member-name {
  color: gray;
  margin-top: 10px;
  font-size: 12px;
}

.button-box {
  padding: 40px 0;
}

.card-button {
  background: #eeeeee;
  color: #000000;
  font-size: 14px;
  border: none;
  display: flex;
  width: 120px;
  height: 35px;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}
.conversation-list-content {
    flex: 1;
    overflow-y: auto;
    padding: 10px 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .conversation-list-content::-webkit-scrollbar {
    display: none;
  }

  .no-conversation {
    text-align: center;
    color: #666666;
  }

</style>
